import { getLanguage } from 'utils/language/language';
import idConfig from 'utils/ecommerce/services/id.config';
import { env as E } from 'config/app.config';

export const getOrderTracking = (orderId: string) => {
	const language = (idConfig.LANGUAGE as any)[getLanguage().toUpperCase()];
	const storeId = (idConfig.ESHOP as any)?.['PRODUCTS']?.['STORE_ID']?.[E];
	return {
		url: `/wcs/resources/store/${storeId}/order/${orderId}?langId=${language}`,
		method: 'GET',
	};
};
